import React from "react";
import { Spin, Upload } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import TrashIcon from "../../../Common/Svgs/TrashIcon";
import UploadIcon from "../../../Common/Svgs/UploadIcon";
import AlertIcon from "../../../Common/Svgs/AlertIcon";

const PhotoUpload = ({
  identifier,
  url,
  upload,
  setUpload,
  setValue,
  handleLicenseUpload,
}) => {
  if (url) {
    return (
      <div className="w-[367px]">
        <p className="font-aileron font-normal text-xs text-dark-gray mb-1.5">
          Please upload a PNG/JPEG not more than 2 Mb
        </p>

        <div className="flex items-center justify-between">
          <div className="w-[72px] h-[42px] px-2 border border-green rounded-md">
            <img
              src={url}
              alt="license"
              className="w-full h-full object-contain"
            />
          </div>

          <button
            type="button"
            className="flex items-center justify-end px-2 py-1 mt-3 rounded-md gap-x-2"
            onClick={() => {
              setUpload({ loading: false, error: "", progress: 0, name: "" });
              setValue(identifier, "");
            }}
          >
            <TrashIcon className="text-black" />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="w-[367px]">
      <div>
        <p className="font-aileron font-normal text-xs text-dark-gray mb-1.5">
          Please upload a PNG/JPEG not more than 2 Mb
        </p>

        <Upload
          customRequest={(options) => handleLicenseUpload(options)}
          showUploadList={false}
          maxCount={1}
          multiple={false}
          accept="image/png, image/jpeg, image/jpg"
          disabled={upload?.loading}
        >
          <button
            type="button"
            className="flex items-center gap-x-2 max-w-max bg-yellow hover:bg-yellow-dark px-4 py-3 rounded-md"
          >
            <UploadIcon />
            <p className="font-poppins font-medium text-xs">Upload</p>
          </button>
        </Upload>

        {upload?.loading ? (
          <div className="mt-2 flex items-center gap-x-2">
            <div className="w-[42px] h-[42px] flex items-center justify-center">
              <Spin
                spinning={upload?.loading}
                indicator={<LoadingOutlined color="#fad152" />}
              />
            </div>

            <div className="flex-1">
              <p className="font-poppins font-medium text-xs text-[#000C1E]">
                {upload?.name}
              </p>

              <div className="mt-1 relative flex-1">
                <div
                  className="absolute z-[20] h-[2px] bg-green rounded-full"
                  style={{ width: upload?.progress }}
                />

                <div className="w-full h-[2px] bg-[#DFDFDF] rounded-full" />
              </div>
            </div>
          </div>
        ) : null}

        {upload?.error ? (
          <div className="mt-2 flex items-center gap-x-2">
            <AlertIcon size={24} className="text-alert-red" />

            <p className="font-aileron font-normal text-xs text-[#000C1E]">
              {upload.error}
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PhotoUpload;
